export default "__VITE_ASSET__s643mefc__"